import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["preview", "label"]

  update(event) {
    const input = event.target
    const label = this.hasLabelTarget ? this.labelTarget : input.nextElementSibling
    
    if (input.files && input.files.length > 0) {
      const files = Array.from(input.files)
      const fileCount = files.length
      
      // Update label to show selected state
      if (label) {
        label.innerHTML = `
          <div class="flex flex-col items-center">
            <svg class="w-8 h-8 text-green-500 mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7"></path></svg>
            <p class="text-[10px] font-black text-gray-900 uppercase">${fileCount} ${fileCount === 1 ? 'File' : 'Files'} Selected</p>
            <p class="text-[8px] text-blue-600 font-bold mt-1 uppercase tracking-widest">Click to Change</p>
          </div>
        `
        label.classList.add("border-green-500", "bg-green-50/30")
      }

      if (this.hasPreviewTarget) {
        this.previewTarget.innerHTML = "" // Clear existing previews
        this.previewTarget.classList.remove("hidden")

        files.forEach(file => {
          if (file.type.startsWith('image/')) {
            const reader = new FileReader()
            reader.onload = (e) => {
              const previewItem = document.createElement("div")
              previewItem.className = "relative mt-4 group"
              previewItem.innerHTML = `
                <img src="${e.target.result}" class="w-full h-48 object-cover rounded-2xl border-2 border-gray-100 shadow-sm transition group-hover:opacity-90">
                <div class="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition">
                  <span class="bg-gray-900/60 text-white text-[10px] font-black px-3 py-1.5 rounded-full uppercase tracking-widest">Preview</span>
                </div>
              `
              this.previewTarget.appendChild(previewItem)
            }
            reader.readAsDataURL(file)
          } else {
            // Show icon for non-image files (PDF etc)
            const previewItem = document.createElement("div")
            previewItem.className = "mt-4 p-4 bg-blue-50 border border-blue-100 rounded-2xl flex items-center gap-3"
            const icon = file.type === 'application/pdf' 
              ? `<svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"></path></svg>`
              : `<svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path></svg>`
            
            previewItem.innerHTML = `
              <div class="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center text-white flex-shrink-0">
                ${icon}
              </div>
              <div class="overflow-hidden">
                <p class="text-[9px] font-black text-blue-900 uppercase tracking-widest leading-none mb-1 truncate">${file.type.split('/')[1].toUpperCase() || 'FILE'}</p>
                <p class="text-[10px] font-bold text-blue-600 truncate">${file.name}</p>
              </div>
            `
            this.previewTarget.appendChild(previewItem)
          }
        })
      }
    }
  }
}
